import axios from "axios";
// import getAuthHeader from "../utils/authHeader";

const baseURL = process.env.VUE_APP_API_URL;

export default {
  async get(url) {
    // const headers = await getAuthHeader(url);
    try {
      const response = await axios.get(`${baseURL}${url}`);
      return response;
    } catch (error) {
      return error.response || error;
    }
  },

  async getById(url, id) {
    // const headers = await getAuthHeader(url);
    let getURL = `${baseURL}${url}${id ? `/${id}` : ""}`;

    try {
      const response = await axios.get(getURL);
      return response;
    } catch (error) {
      return error.response || error;
    }
  },

  async getByIdQurey(url, field, id) {
    // const headers = await getAuthHeader(url);
    let getURL = id ? `${baseURL}${url}?${field}=${id}` : `${baseURL}${url}`;

    try {
      const response = await axios.get(getURL);
      return response;
    } catch (error) {
      return error.response || error;
    }
  },

  async post(url, model, id) {
    // const headers = await getAuthHeader(url);
    let apiurl = `${baseURL}${url}${id ? `/${id}` : ""}`;

    try {
      const response = await axios.post(apiurl, model);
      return response;
    } catch (error) {
      return error.response || error;
    }
  },

  async put(url, model, id) {
    // const headers = await getAuthHeader(url);
    let apiurl = `${baseURL}${url}${id ? `/${id}` : ""}`;

    try {
      const response = await axios.put(apiurl, model);
      return response;
    } catch (error) {
      return error.response || error;
    }
  },

  async patch(url, model, id) {
    // const headers = await getAuthHeader(url);
    let apiurl = `${baseURL}${url}${id ? `/${id}` : ""}`;

    try {
      const response = await axios.patch(apiurl, model);
      return response;
    } catch (error) {
      return error.response || error;
    }
  },

  async delete(url) {
    // const headers = await getAuthHeader(url);
    try {
      const response = await axios.delete(`${baseURL}${url}`);
      return response;
    } catch (error) {
      return error.response || error;
    }
  },
};